
import React, { useState } from 'react';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { useDebouncedCallback } from 'use-debounce';
import { supabase } from '@/integrations/supabase/client';

interface HebrewDescriptionInputProps {
  value: string;
  onChange: (value: string, translatedValue: string) => void;
}

export const HebrewDescriptionInput = ({ value, onChange }: HebrewDescriptionInputProps) => {
  const [isTranslating, setIsTranslating] = useState(false);

  const debouncedTranslate = useDebouncedCallback(async (hebrewText: string) => {
    if (hebrewText.trim()) {
      setIsTranslating(true);
      try {
        const { data, error } = await supabase.functions.invoke('translate', {
          body: { text: hebrewText }
        });

        if (error) throw error;
        if (data?.translation) {
          onChange(hebrewText, data.translation);
        }
      } catch (error) {
        console.error('Translation error:', error);
      } finally {
        setIsTranslating(false);
      }
    }
  }, 1000);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const hebrewText = e.target.value;
    onChange(hebrewText, '');
    debouncedTranslate(hebrewText);
  };

  return (
    <div>
      <Label htmlFor="hebrewDescription" dir="rtl" className="block text-right w-full">תיאור המשימה בעברית</Label>
      <Textarea
        id="hebrewDescription"
        dir="rtl"
        value={value}
        onChange={handleChange}
        className="mt-1 text-right"
        placeholder="הכנס תיאור משימה"
      />
    </div>
  );
};
